export default __webpack_public_path__ + "static/media/sideImage_2.27072499.png";